import { H3Tag, ImageTag, SpanTag } from "@tm/static";
import { theme } from "@tm/utility/global";
import { IWhyBookProps } from "./types";
import {
  BenefitCard,
  BenefitsGrid,
  BenefitTextBlock,
  Container,
} from "./WhyBook.styles";

const WhyBook = ({ title, benefits }: IWhyBookProps) => {
  const validBenefits = benefits?.filter(Boolean) ?? [];

  if (!title && validBenefits.length === 0) return null;

  return (
    <Container>
      {title && <H3Tag margin="0 0 32px">{title}</H3Tag>}
      {validBenefits.length > 0 && (
        <BenefitsGrid>
          {validBenefits.map((benefit, idx) => (
            <BenefitCard key={idx}>
              {benefit.icon && (
                <ImageTag src={benefit.icon} width="36px" height="36px" />
              )}
              <BenefitTextBlock>
                {benefit.title && (
                  <SpanTag fontSize="large" fontWeight="black">
                    {benefit.title}
                  </SpanTag>
                )}
                {benefit.subtitle && (
                  <SpanTag
                    fontSize="md"
                    color={theme.greyText}
                    style={{ opacity: 0.9 }}
                  >
                    {benefit.subtitle}
                  </SpanTag>
                )}
              </BenefitTextBlock>
            </BenefitCard>
          ))}
        </BenefitsGrid>
      )}
    </Container>
  );
};

export default WhyBook;
